<template>
    <!-- 查看试卷 -->
    <div :class="isReviewDetails ? 'board look-paper-back' : 'board'">
        <div class="h100p">
            <div class="title" v-if="!isReviewDetails">
                <span>
                    <el-button type="text" icon="el-icon-arrow-left" @click="$router.push({name:'examineeScore'})">{{ lookPaperTextConfig.back }}</el-button>
                    <el-divider direction="vertical"></el-divider>
                    <span class="name">{{ lookPaperTextConfig.title }}</span>
                </span>
            </div>
            <div :class="isReviewDetails ? 'questionCon review-details-height' : 'questionCon'" v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading">
                <el-button v-if="info.examCategory !== 'normal' && isReviewDetails" type="text" icon="el-icon-arrow-left" @click="$router.push({name:'examineeScore'})" style="height: 48px; margin-top: -15px; margin-right: 10px">{{ lookPaperTextConfig.back }}</el-button>

                <div class="left">
                    <el-descriptions title="" :column="2" v-if="info.examineeName">
                        <el-descriptions-item :label="lookPaperTextConfig.info.examineeName + '：'">{{ info.examineeName }}</el-descriptions-item>
                        <el-descriptions-item :label="lookPaperTextConfig.info.commitAnswerTime + '：'">{{ info.commitDate }}</el-descriptions-item>
                        <el-descriptions-item :label="lookPaperTextConfig.info.admissionNo + '：'">{{ info.admissionNo }}</el-descriptions-item>
                        <el-descriptions-item :label="lookPaperTextConfig.info.reviewStatus + '：'">
                            <el-tag :type="info.reviewStatus === 1 ? 'warning' : info.reviewStatus === 2 ? 'success' : ''">{{ reviewStatusFormatter(info.reviewStatus) }}</el-tag>
                        </el-descriptions-item>
                    </el-descriptions>

                    <el-card class="box-card" shadow="hover" v-if="isHaveIntroduction()" style="margin-bottom: 18px">
                        <div>
                            <div style="font-size: 16px; font-weight: bold">竞赛说明</div>
                            <hr>
                            <div v-html="this.examPaper.introduction" style="max-height: 300px; overflow-y: auto"></div>
                        </div>
                    </el-card>

                    <el-card class="box-card" shadow="hover" style="padding-bottom: 20px; margin-top: 0" v-if="!info.examineeName">
                        <div class="title" style="font-size: 20px; font-weight: bold">
                            {{ examPaper.name }}

                            <el-tag v-if="answerSheet.reviewStatus === 2" type="success">已批阅</el-tag>
                            <el-tag v-else type="info">未批阅</el-tag>
                        </div>
                        <div>
                            <div style="float: left; width: 150px; height: 150px; background-color: #f5f5f5; text-align: center">
                                <p v-if="answerSheetReviewResult.score || answerSheetReviewResult.score == 0" style="margin-top: 35px; color: #daa43a"><span style="font-size: 40px">{{ answerSheetReviewResult.score }}</span>分</p>
                                <p v-else style="margin-top: 35px"><span style="font-size: 40px; margin-right: 10px">?</span>分</p>
                                <p style="color:#bab5af;">总分 {{ examPaper.total_score }}</p>
                            </div>
                            <div class="review-result-table">
                                <el-table
                                    :data="reviewResultTable"
                                    style="width: 100%">
                                    <el-table-column
                                        prop="questionType"
                                        label="题型"
                                        width="100">
                                    </el-table-column>
                                    <el-table-column
                                        prop="rightNum"
                                        label="正确"
                                        width="120">
                                    </el-table-column>
                                    <el-table-column
                                        prop="someRightNum"
                                        label="部分正确"
                                        width="120">
                                    </el-table-column>
                                    <el-table-column
                                        prop="errorNum"
                                        label="答错"
                                        width="120">
                                    </el-table-column>
                                    <el-table-column
                                        prop="nullNum"
                                        label="未答"
                                        width="120">
                                    </el-table-column>
                                    <el-table-column
                                        prop="score"
                                        label="得分">
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </el-card>
                    <div v-for="(item, index) in question" :key="index">
                        <el-card class="box-card" :id="'module' + index" shadow="hover" v-if="item.question_num > 0">
                            <div slot="header" class="unClearfix">
                                <span>{{ item.name }}</span>
                                <span>
                                    {{ questionTextConfig.tip.signMix(item.question_num, item.total_score) }}
                                </span>
                            </div>
                            <div class="questionModle" :id="'module' + index + 'question' + i" v-for="(e, i) in item.question_list" :key="i">
                                <span>{{ i + 1 }}.</span>
                                <p v-html="e.newStem" class="ql-editor"></p>
                                <div v-if="e.crosshead">
                                    <div v-for="(n, l) in e.crosshead" :key="l">
                                        <span style="position:relative;top:6px;vertical-align: top;">（{{ l + 1 }}）</span><p v-html="n.newStem" class="ql-editor" style="display: inline-block; max-width: calc(100% - 45px);"></p>
                                    </div>
                                </div>
                                <p style="margin:10px 0" v-if="e.attachment">
                                    <el-tag v-if="e.attachment.stem" @click="questionStatus(index, i)" type="medium">
                                        {{ questionTextConfig.attachment }} {{ e.attachment.stem.file_name }}&nbsp;&nbsp;
                                        <el-tooltip class="item" effect="dark" :content="questionTextConfig.preview" placement="top" v-if="checkFileType(e.attachment.stem.file_name)">
                                            <i class="el-icon-search" style="cursor: pointer;" @click="questionStatus(index, i), seeIframe(e.attachment.stem.file_path)"></i>
                                        </el-tooltip>&nbsp;
                                        <el-tooltip class="item" effect="dark" :content="questionTextConfig.download" placement="top">
                                            <a :href="config_env.BASE_URL + getDownloadAddress(e.attachment.stem.file_path, e.attachment.stem.file_name)" @click="questionStatus(index, i)"><i class="el-icon-download"></i></a>
                                        </el-tooltip>
                                    </el-tag>
                                </p>
                                <el-button v-if="item.question_type == 'subjectivity' && e.training_id" :disabled="true" type="primary" size="mini" icon="el-icon-monitor" style="margin:10px 0 0">
                                    {{ e.training_label }}</el-button>
                                <ul v-if="item.question_type != 'fill' && item.question_type != 'subjectivity'" style="padding-left:0">
                                    <li v-for="(f, j) in e.choices" :key="j" style="display:block;">
                                        {{ letter[j] }} .&nbsp;&nbsp;
                                        <span v-html="f" class="ql-editor" style="display:inline-flex"></span>
                                    </li>
                                </ul>
                                <div class="questAnswer" v-if="e.review_mode !== 'script'">
                                    <span class="questLabel" style="margin-top:9px;font-size:14px;line-height: 28px;">{{ examineeAnswerTextConfig.name }}：</span>
                                    <div v-if="item.question_type == 'subjectivity'" class="subjectivity">
                                        <div v-if="e.submit_mode && e.submit_mode.includes('text') || e.answer_way == 'text' ||e.answer_way == 'full'">
                                            <div v-if="e.crosshead.length > 0">
                                                <div v-for="(n, l) in e.crosshead" :key="l" style="margin-bottom:10px !important;position: relative;">
                                                    <span class="questIndex">（{{ l + 1 }}）&nbsp;</span>
                                                    <div class="container">
                                                        <p class="answerBox" v-html="filterAnswer(e.id, e.type, examineeAnswer)[l]"></p>
                                                        <div v-if="isPrivilegedMode" class="edit-icon">
                                                            <i class="el-icon-edit" @click="updateAnswer(e.id, l, 'text', e.crosshead)"></i>
                                                        </div>
                                                    </div>
                                                    <el-tooltip v-if="e.reviewScore" effect="dark" placement="top" style="position:absolute;top:1px;right:33px">
                                                        <template #content>
                                                            <div style="white-space:pre-line;">{{ e.comment }}</div>
                                                        </template>
                                                        <el-button
                                                            class="scoreTag"
                                                            :type="e.reviewType === 1 ? 'success' : e.reviewType === 0 ? 'danger' : 'warning'"
                                                            effect="dark" size="mini">
                                                            {{ examineeAnswerTextConfig.score.signMix(e.reviewScore[l]) }}
                                                        </el-button>
                                                    </el-tooltip>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <div class="container">
                                                    <p class="answerBox" v-html="filterAnswer(e.id, e.type, examineeAnswer)[0] || ''"></p>
                                                    <div v-if="isPrivilegedMode" class="edit-icon" style="right: 145px">
                                                        <i class="el-icon-edit" @click="updateAnswer(e.id, null, 'text')"></i>
                                                    </div>
                                                </div>
                                                <el-tooltip v-if="e.reviewScore" effect="dark" placement="top" style="position:absolute;top:1px;right:33px">
                                                    <template #content>
                                                        <div style="white-space:pre-line;">{{ e.comment }}</div>
                                                    </template>
                                                    <el-button
                                                        class="scoreTag"
                                                        :type="e.reviewType === 1 ? 'success' : e.reviewType === 0 ? 'danger' : 'warning'"
                                                        effect="dark"
                                                        size="mini">
                                                        {{ examineeAnswerTextConfig.score.signMix(e.reviewScore[0]) }}
                                                    </el-button>
                                                </el-tooltip>
                                            </div>
                                        </div>
                                        <div  v-if="e.submit_mode && e.submit_mode.includes('link')">
                                            <el-button type="primary" icon="el-icon-link" size="mini" v-if="e.link"
                                                       style="margin-top:10px" @click="goToLink(e.link)">
                                                访问链接&nbsp;&nbsp;<i v-if="isPrivilegedMode" class="el-icon-edit" @click.stop="updateAnswer(e.id, null, 'link')"></i>
                                            </el-button>
                                            <el-tooltip v-if="e.reviewScore && !e.submit_mode.includes('text') && e.submit_mode.includes('link')" effect="dark" placement="top" style="position:absolute;top:1px;right:33px">
                                                <template #content>
                                                    <div style="white-space:pre-line;">{{ e.comment }}</div>
                                                </template>
                                                <el-button
                                                        class="scoreTag"
                                                        :type="e.reviewType === 1 ? 'success' : e.reviewType === 0 ? 'danger' : 'warning'"
                                                        effect="dark" size="mini">
                                                    {{ examineeAnswerTextConfig.score.signMix(sumScore(e.reviewScore)) }}
                                                </el-button>
                                            </el-tooltip>
                                        </div>
                                        <div  v-if="e.submit_mode && e.submit_mode.includes('attachment') || e.answer_way == 'attachment' ||e.answer_way == 'full'">
                                            <el-tag type="medium" style="margin-top:7px;font-size:14px;line-height:28px;height:28px;" v-if="e.examineeFile.file||isPrivilegedMode">
                                                {{ examineeAnswerTextConfig.attachment }}&nbsp;&nbsp;{{e.examineeFile.fileName}}&nbsp;&nbsp;
                                                <el-tooltip class="item" effect="dark" :content="examineeAnswerTextConfig.preview" placement="top" v-if="checkFileType(e.examineeFile.fileName)">
                                                    <i v-if="!attachmentDownloadDisabled" class="el-icon-search" @click="seeIframe(e.examineeFile.file)" style="cursor: pointer;"></i>
                                                </el-tooltip>&nbsp;
                                                <el-tooltip class="item" effect="dark" :content="examineeAnswerTextConfig.download" placement="top">
                                                    <a v-if="!attachmentDownloadDisabled" :href="config_env.BASE_URL + getDownloadAddress(e.examineeFile.file, e.examineeFile.fileName)"><i class="el-icon-download"></i></a>
                                                </el-tooltip>&nbsp;
                                                <el-tooltip v-if="isPrivilegedMode" class="item" effect="dark" content="更新附件" placement="top">
                                                    <i class="el-icon-edit" style="cursor: pointer;" @click="updateAttachment(e.id)"></i>
                                                </el-tooltip>
                                            </el-tag>
                                            <el-tooltip v-if="e.reviewScore && (e.submit_mode && e.submit_mode.length == 1 && e.submit_mode.includes('attachment') || e.answer_way == 'attachment')" effect="dark" placement="top" style="position:absolute;top:1px;right:33px">
                                                <template #content>
                                                    <div style="white-space:pre-line;">{{ e.comment }}</div>
                                                </template>
                                                <el-button
                                                        class="scoreTag"
                                                        :type="e.reviewType === 1 ? 'success' : e.reviewType === 0 ? 'danger' : 'warning'"
                                                        effect="dark"
                                                        size="mini">
                                                    {{ examineeAnswerTextConfig.score.signMix(sumScore(e.reviewScore)) }}
                                                </el-button>
                                            </el-tooltip>
                                        </div>
                                    </div>
                                    <span v-else-if="item.question_type == 'fill'" style="position:relative;top:9px;font-weight:600;font-size:16px;">
                                        <span v-for="(an, a) in filterAnswer(e.id, e.type, examineeAnswer)" :key="a">
                                            <br v-if="a !== 0" />
                                            （{{ a + 1 }}）{{ an || '____________' }}
                                        </span>
                                    </span>
                                    <span v-else style="position:relative;top:9px;font-weight:600;font-size:16px;">
                                        {{ choiceFilterAnswer(e.id, e.type, examineeAnswer) }}
                                    </span>
                                    <el-tag
                                        v-if="(e.reviewScore || e.reviewScore === 0) && item.question_type !== 'subjectivity'"
                                        class="scoreTag"
                                        :type="e.reviewType === 1 ? 'success' : e.reviewType === 0 ? 'danger' : 'warning'"
                                        effect="dark"
                                        size="medium">
                                        {{ examineeAnswerTextConfig.score.signMix(e.reviewScore) }}
                                    </el-tag>
                                </div>

                                <!-- 操作日志 -->
                                <div class="questAnswer" v-if="item.question_type == 'subjectivity' && e.review_mode === 'script'">
                                    <span class="questLabel" style="margin-top:9px;font-size:14px;line-height: 28px;">{{examineeAnswerTextConfig.name}}：</span>

                                    <div class="subjectivity" v-if="operateHistory[e.id]">
                                        <p class="answerBox">【{{e.training_label}}实操环境日志】<br>{{ operateHistory[e.id] }}</p>
                                    </div>
                                    <p v-else style="margin-top:9px;font-size:14px;line-height: 28px;">【{{e.training_label}}实操环境日志】<br>日志数据为空</p>
                                </div>
                                <!-- 校验结果 -->
                                <div class="questAnswer" v-if="item.question_type == 'subjectivity' && e.review_mode === 'script'">
                                    <span class="questLabel" style="margin-top:9px;font-size:14px;line-height: 28px;">校验结果：</span>

                                    <div class="subjectivity">
                                        <el-table
                                            :data="validResultData[e.id]"
                                            style="width: 100%">
                                            <el-table-column
                                                v-if="e.crosshead.length > 0"
                                                prop="question_crosshead_index"
                                                label="小题序号">
                                                <template slot-scope="scope">
                                                    {{scope.row.question_crosshead_index == null ? "": scope.row.question_crosshead_index + 1}}
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                prop="script_execute_result_message"
                                                label="校验结果">
                                            </el-table-column>
                                            <el-table-column
                                                prop="script_execute_result_score"
                                                label="本次得分/总分">
                                                <template slot-scope="scope">
                                                    {{scope.row.script_execute_result_score == null ? '?' :  scope.row.script_execute_result_score}}/{{e.crosshead && e.crosshead.length == 0 ? e.score : scope.row.question_crosshead_index == null ? e.score : e.crosshead[scope.row.question_crosshead_index].score}}
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </div>
                                </div>

                                <div v-if="!info.isExaminee || info.examIsDisplayAnswer" style="padding-top:20px">
                                    <el-button
                                        v-if="e.showAnswer"
                                        size="mini"
                                        @click="questionStatus(index, i), e.showAnswer = false, $forceUpdate()">
                                        {{ correctAnswerTextConfig.retract }}<i class="el-icon-arrow-up"></i>
                                    </el-button>
                                    <el-button
                                        v-else
                                        size="mini"
                                        @click="questionStatus(index, i), e.showAnswer = true, $forceUpdate()">
                                        {{ correctAnswerTextConfig.expand }}<i class="el-icon-arrow-down"></i>
                                    </el-button>

                                    <el-descriptions title="" :column="1" v-show="e.showAnswer" v-if="questionAnswer[e.id]">
                                        <el-descriptions-item :label="correctAnswerTextConfig.name + '：'">
                                            <div v-if="item.question_type == 'subjectivity'" class="subjectivity">
                                                <p v-html="returnAnswer(questionAnswer[e.id].answer || [''], e.type)[0] || ''"></p>
                                            </div>
                                            <span v-else-if="item.question_type == 'fill'" style="position:relative;top:2px;font-weight:600;">
                                                <span v-for="(an, a) in returnAnswer(questionAnswer[e.id].answer || [''], e.type)" :key="a">
                                                    <br v-if="a !== 0" />
                                                    （{{ a + 1 }}）{{ an.join(correctAnswerTextConfig.joinStr) }}
                                                </span>
                                            </span>
                                            <span v-else style="position:relative;top:2px;font-weight:600;">
                                                {{ returnAnswer(questionAnswer[e.id].answer || [''], e.type) }}
                                            </span>
                                            <el-tag v-if="questionAnswer[e.id].answer_file" type="medium">
                                                {{ correctAnswerTextConfig.attachment }} {{ questionAnswer[e.id].answer_file.file_name }}&nbsp;&nbsp;
                                                <el-tooltip
                                                    class="item"
                                                    effect="dark"
                                                    :content="correctAnswerTextConfig.preview"
                                                    placement="top"
                                                    v-if="checkFileType(questionAnswer[e.id].answer_file.file_name)">
                                                    <i class="el-icon-search"
                                                       style="cursor: pointer;"
                                                       @click="questionStatus(index, i), seeIframe(questionAnswer[e.id].answer_file.file_path)">
                                                    </i>
                                                </el-tooltip>
                                                &nbsp;
                                                <el-tooltip class="item" effect="dark" :content="correctAnswerTextConfig.download" placement="top">
                                                    <a :href="config_env.BASE_URL + getDownloadAddress(questionAnswer[e.id].answer_file.file_path, questionAnswer[e.id].answer_file.file_name)"
                                                        @click="questionStatus(index, i)">
                                                        <i class="el-icon-download"></i>
                                                    </a>
                                                </el-tooltip>
                                            </el-tag>
                                        </el-descriptions-item>
                                        <el-descriptions-item :label="analysisTextConfig.name + '：'" v-if="questionAnswer[e.id].analysis || questionAnswer[e.id].analysis_file">
                                            <span v-html="questionAnswer[e.id].analysis"></span>
                                            <el-tag v-if="questionAnswer[e.id].analysis_file" type="medium">
                                                {{ analysisTextConfig.attachment }} {{ questionAnswer[e.id].analysis_file.file_name }}&nbsp;&nbsp;
                                                <el-tooltip
                                                    class="item"
                                                    effect="dark"
                                                    :content="analysisTextConfig.preview"
                                                    placement="top"
                                                    v-if="checkFileType(questionAnswer[e.id].analysis_file.file_name)">
                                                    <i class="el-icon-search"
                                                       style="cursor: pointer;"
                                                       @click="questionStatus(index, i), seeIframe(questionAnswer[e.id].analysis_file.file_path)">
                                                    </i>
                                                </el-tooltip>&nbsp;
                                                <el-tooltip
                                                    class="item"
                                                    effect="dark"
                                                    :content="analysisTextConfig.download"
                                                    placement="top">
                                                    <a :href="config_env.BASE_URL + getDownloadAddress(questionAnswer[e.id].analysis_file.file_path, questionAnswer[e.id].analysis_file.file_name)"
                                                       @click="questionStatus(index, i)">
                                                        <i class="el-icon-download"></i>
                                                    </a>
                                                </el-tooltip>
                                            </el-tag>
                                        </el-descriptions-item>
                                    </el-descriptions>
                                </div>
                            </div>
                        </el-card>
                    </div>
                </div>
                <div class="right">
                    <el-button type="primary" @click="examAgain" v-if="info.examCategory !== 'normal' && !info.examineeName" style="margin-bottom: 10px">再答一次</el-button>
                    <el-card class="box-card" shadow="hover" :style="!info.examineeName ? 'height: calc(100% - 42px) !important' : ''">
                        <div slot="header" class="clearfix">
                            <span>{{ answerSheetTextConfig.name }}</span>
                            <span>{{ answerSheetTextConfig.reviewed }} {{reviewResult.length}} / {{questionNum}}</span>
                        </div>
                        <div class="questionButtons">
                            <div v-for="(item, index) in question" :key="index" v-show="item.question_num > 0" style="margin-bottom:6px">
                                <a @click="questionStatus(index, 0, 'module')" style="padding-bottom:5px">{{ item.name }}</a>
                                <div>
                                    <span v-for="(e, i) in item.question_list" :key="i" class="questionButton">
                                        <a @click="questionStatus(index, i, 'question'), $forceUpdate()">
                                            <el-button :plain="e.nowType?false:true" :type="e.reviewType === 1 ? 'success' : e.reviewType === 0 ? 'danger' : e.reviewType === 2 ? 'warning' : e.nowType?'primary':''" style="width:100%">{{ i + 1 }}</el-button>
                                        </a>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <p class="spaceBetween">
                            <el-tag type="success">{{ answerSheetTextConfig.success }}</el-tag>
                            <el-tag type="danger">{{ answerSheetTextConfig.danger }}</el-tag>
                            <el-tag type="warning">{{ answerSheetTextConfig.warning }}</el-tag>
                            <el-tag type="info" effect="plain">{{ answerSheetTextConfig.unreview }}</el-tag>
                        </p>
                    </el-card>
                </div>
            </div>
        </div>
        <update-answer :key="key" :answer.sync="answer" :show.sync="answer.show" @close="updateAnswerCallback"></update-answer>
        <file-upload :show.sync="importDialogVisible" @close="uploadFileCallback"></file-upload>
    </div>
</template>

<script>
import quillEditor from '@/components/editor/index.vue'
import fileUpload from '@/components/fileUpload/index.vue'
import updateAnswer from './components/updateAnswer'
import { getDownloadAddress } from '@/utils/common.js'
import {getDict} from "@/api/dict"
import {getAnswerSheet, getAnswerSheetByAdmin, getAnswerSheetById, modifyAnswer, initAnswer} from "@/api/exam";
import {findResultByAnswerSheetId} from "@/api/reviewResult";
import {getExamPaper, getExamPaperAnswer, getExamPaperAnswerByAdmin} from "@/api/arrangement";
import {getOperateHistory} from "@/api/training";
import Cookies from "js-cookie";
import {getList} from "@/api/backup";

export default {
    components: {
        quillEditor,
        updateAnswer,
        fileUpload
    },
    props: ['examConfig', 'userExamPaperList', 'examDurationUnitOptions'],
    data() {
        return {
            key: Date.now(),
            loading: true,
            info: {},
            statusOptions: [],
            examPaper: {},
            questionNum: 0,
            questionScore: 0,
            reviewResultTable: [],
            letter: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
            question: [],
            answerSheet: {},
            examineeAnswer: [],
            questionAnswer: {},
            answerSheetReviewResult: {},
            reviewResult: [],
            status: 0,
            okNum: 0,
            questionTypeDict: [],
            validResultData: {},
            operateHistory: {},
            examTimer: null,
            answer: {
                show: false,
                id: null,
                subQuestionIndex: null,
                type: null,
            },
            importDialogVisible: false,
            // 禁用附件下载及预览功能
            attachmentDownloadDisabled: false,
        }
    },
    computed: {
        showQuestionScore() {
            return this.$store.state.global.textConfig.showQuestionScore
        },
        lookPaperTextConfig() {
            return this.$store.state.global.textConfig.backend.lookPaper
        },
        questionTextConfig() {
            return this.lookPaperTextConfig.question
        },
        examineeAnswerTextConfig() {
            return this.lookPaperTextConfig.examineeAnswer
        },
        correctAnswerTextConfig() {
            return this.lookPaperTextConfig.correctAnswer
        },
        analysisTextConfig() {
            return this.lookPaperTextConfig.analysis
        },
        answerSheetTextConfig() {
            return this.lookPaperTextConfig.answerSheet
        },
        isReviewDetails() {
            return window.location.pathname === '/reviewDetails'
        },
        fileTypeList() {
            if (this.$store.state.global.textConfig.filePreview && this.$store.state.global.textConfig.filePreview.extensions) {
                let extensions = this.$store.state.global.textConfig.filePreview.extensions;
                return extensions.replaceAll(' ', '').split(',');
            } else {
                return ['ipynb', 'jpg','png','docx', 'doc','csv','txt','xlsx'];
            }
        },
        isPrivilegedMode() {
            return sessionStorage.getItem('privilege') === 'true'
        }
    },
    created() {
        let info = JSON.parse(localStorage.getItem('setExamineePaperInfo'))
        this.info = info
        this.getQuestion(info.examPaperId)
        this.getQuestionAnswer(info.examPaperId)
        getDict('review_status').then(res => {
            this.statusOptions = res.data
        })
        getDict('question_type').then(res => {
            this.questionTypeDict = res.data
        })

        if (this.info.isExaminee) {
            this.examCountDown();
        }
        this.getExamBackupStatus()
    },
    destroyed() {
        clearInterval(this.examTimer)
    },
    methods: {
        getExamBackupStatus() {
            if (this.info.examId) {
                let params = {
                    examId: this.info.examId,
                    examPlanName: '',
                    subject: '',
                    ids: '',
                    pageNumber: 1,
                    pageSize: 1
                }

                getList(params).then(res => {
                    if (res.status === 200) {
                        let items = res.data.list || []
                        if (items && items[0]) {
                            let backupStatus = items[0].backupStatus
                            // 附件已删除
                            if (backupStatus != 'online') {
                                this.attachmentDownloadDisabled = true
                            }
                        }
                    }
                })
            }
        },
        isHaveIntroduction() {
            if (this.examPaper.introduction) {
                return this.examPaper.introduction.replace(/<\/?[^>]+(>|$)/g, "")
            } else {
                return false
            }
        },
        examAgain() {
            getAnswerSheet(this.info.examPaperId).then(() => {
                localStorage.setItem('examAgain', this.info.examPaperId)
                this.$router.push('/candidate')
            })
        },
        getDownloadAddress,
        getTagValue(val, options) {
            for (let i = 0; i < options.length; i++) {
                const e = options[i]
                if (e.value == val) {
                    return e.label
                }
            }
        },
        returnAnswer(answer, type) {
            if (type === 'single_choice') {
                return this.letter[answer[0]]
            } else if (type === 'choice' || type === 'uncertain_choice') {
                return this.choice(answer)
            } else if (type === 'determine') {
                return this.determine(answer)
            } else {
                return answer
            }
        },
        filterAnswer(id, type, answerList) {
            const arr = answerList.filter((item) => item.questionId === id)
            if (arr.length) {
                let answer = arr[0].answer
                return this.returnAnswer(answer, type)
            } else {
                return ['']
            }
        },
        choiceFilterAnswer(id, type, answerList) {
            const arr = answerList.filter((item) => item.questionId === id)
            if (arr.length) {
                let answer = arr[0].answer
                return this.returnAnswer(answer, type)
            } else {
                return ''
            }
        },
        choice(answer) {
            let arr = []
            if (answer) {
                for (let i = 0; i < answer.length; i++) {
                    const j = answer[i]
                    arr.push(this.letter[j])
                }
            }
            return arr.join(' ')
        },
        determine(answer) {
            if (answer[0] === 0) {
                return '错误'
            } else if (answer[0] === 1) {
                return '正确'
            }
        },
        checkFileType(name) {
            if (!name) {
                return false
            }

            let type = name.split('.')
            if (this.fileTypeList.indexOf(type[1])===-1) {
                return false
            } else {
                return true
            }
        },
        seeIframe(url) {
            window.open(this.FILE_PREVIEW_URL + '/onlinePreview?url=' + encodeURIComponent(this.config_env.BASE_URL + url))
        },
        seeShare(e) {
            let name = localStorage.getItem('1+XUserIdentity')
            this.$store.dispatch('getTrainingInstanceSrc', e.training_id).then((res) => {
                if (res.status == 200) {
                    let routeUrl = this.$router.resolve({
                        path: '/practicalTraining',
                        query: { name, time: null, trainingMirror: e.training_id, questionId: e.id,reviewMode:e.review_mode },
                    })
                    window.open(routeUrl.href, '_blank')
                }
            })
        },
        questionStatus(index, n, type) {

            if (type) {
                const parent = document.querySelector('.left');
                if (type === 'module') {
                    const child = document.querySelector(`#module${index}`);
                    parent.scrollTo({top: (child.offsetParent.offsetTop + child.offsetTop - 180), behavior: "smooth"});
                } else if (type === 'question') {
                    const child = document.querySelector(`#module${index}question${n}`);
                    parent.scrollTo({top: (child.offsetParent.offsetParent.offsetTop + child.offsetParent.offsetTop + child.offsetTop - 180), behavior: "smooth"});
                }
            }

            for (let i = 0; i < this.question.length; i++) {
                const list = this.question[i].question_list
                for (let j = 0; j < list.length; j++) {
                    const e = list[j]
                    e.nowType = null
                }
            }
            this.question[index].question_list[n].nowType = 'primary'
        },
        getQuestion(examPaperId) {
            getExamPaper(examPaperId).then((res) => {
                if (res.status === 200) {
                    this.examPaper = res.data
                    this.question = res.data.confirmed_paper
                    this.questionNum = res.data.question_num
                    for (let i = 0; i < this.question.length; i++) {
                        const list = this.question[i].question_list
                        for (let n = 0; n < list.length; n++) {
                            const li = list[n]
                            li.showAnswer = false
                            li.examineeFile = {file:null}
                            li.link = null
                            if (!li.attachment) {
                                li.attachment = {}
                            }
                            // li.answer = ['']
                            let scoreDiv = this.showQuestionScore ? `<span class="el-tag el-tag--info el-tag--mini scoreTag">${li.score}分</span>` : ''
                            let stem = li.stem
                            if (stem.indexOf('</p>') != -1) {
                                li.newStem = stem.slice(0, -4) + `${scoreDiv}</p>`
                            } else {
                                li.newStem = stem + scoreDiv
                            }
                            if (this.question[i].question_type == 'subjectivity') {
                                if (li.crosshead) {
                                    // li.answer = []
                                    for (let o = 0; o < li.crosshead.length; o++) {
                                        const f = li.crosshead[o]
                                        let str = f.stem
                                        let scoreDiv = this.showQuestionScore ? `<span class="el-tag el-tag--info el-tag--mini scoreTag">${f.score}分</span>` : ''
                                        if (str.indexOf('</p>') != -1) {
                                            f.newStem = str.slice(0, -4) + `${scoreDiv}</p>`
                                        } else {
                                            f.newStem = str + scoreDiv
                                        }
                                        // li.answer.push('')
                                    }
                                } else {
                                    li.crosshead = []
                                }
                                if (li.review_mode === 'script') {
                                    this.initHistory(li.id)
                                }
                            } else if (this.question[i].question_type == 'fill') {
                                let x = 1
                                // li.answer = []
                                li.newStem = li.stem
                                var reg = RegExp(/\[\[(.*?)\]\]/)
                                regExpFun(1)
                                function regExpFun(x) {
                                    if (li.newStem.match(reg)) {
                                        let str = '______(' + x + ')______'
                                        li.newStem = li.newStem.replace(/\[\[(.*?)\]\]/, str)
                                        // li.answer.push('')
                                        regExpFun(x + 1)
                                    } else {
                                        return
                                    }
                                }
                            }
                            this.$forceUpdate()
                        }
                    }
                    this.getExamineeAnswer(this.info.answerSheetId)
                }
            })
        },
        getQuestionAnswer(examPaperId) {
            this.getExamPaperAnswer(examPaperId).then(res => {
                if (res.status === 200) {
                    this.questionAnswer = res.data
                    setTimeout(() => {
                        this.loading = false
                    }, 200)
                }
            })
        },
        getExamPaperAnswer(examPaperId) {
            if (this.info.isExaminee) {
                return getExamPaperAnswer(examPaperId)
            } else {
                return getExamPaperAnswerByAdmin(examPaperId)
            }
        },
        getAnswerSheet(answerSheetId) {
            if (this.info.isExaminee) {
                return getAnswerSheetById(answerSheetId)
            } else {
                return getAnswerSheetByAdmin(answerSheetId)
            }
        },
        getExamineeAnswer(answerSheetId) {
            this.getAnswerSheet(answerSheetId).then(res => {
                if (res.status === 200) {
                    this.answerSheet = res.data
                    this.examineeAnswer = res.data.questionAnswerList

                    // 整理主观题脚本校验结果
                    // this.examineeAnswer.forEach(questionAnswer => {
                    //     if (questionAnswer && questionAnswer.validResult) {
                    //         this.validResultData[questionAnswer.questionId] = JSON.parse(questionAnswer.validResult)
                    //     }
                    // })

                    for (let i = 0; i < this.question.length; i++) {
                        const list = this.question[i].question_list;
                        for (let j = 0; j < list.length; j++) {
                            const li = list[j];
                            const data = this.examineeAnswer.filter((item) => item.questionId === li.id)
                            if (data.length) {
                                li.examineeAnswer = data[0].answer
                                li.examineeFile = {file:data[0].file,fileName:data[0].fileName}
                                li.link = data[0].link
                                // 整理主观题脚本校验结果
                                if (this.question[i].question_type == 'subjectivity' && li.review_mode =='script') {
                                    this.validResultData[li.id] = []
                                    if (li.crosshead && li.crosshead.length > 0) {
                                        if (data[0].validResult) {
                                            let valid = JSON.parse(data[0].validResult)
                                            for (let k = 0; k < li.crosshead.length; k++) {
                                                if (valid) {
                                                    let result = valid.filter(item => item.question_crosshead_index == k)
                                                    if (result && result.length > 0) {
                                                        this.validResultData[li.id].push({
                                                            question_crosshead_index: result[0].question_crosshead_index,
                                                            script_execute_result_message: result[0].script_execute_result_message,
                                                            script_execute_result_score: result[0].script_execute_result_score
                                                        })
                                                    } else {
                                                        this.validResultData[li.id].push({
                                                            question_crosshead_index: k,
                                                            script_execute_result_message: "",
                                                            script_execute_result_score: null
                                                        })
                                                    }
                                                } else {
                                                    this.validResultData[li.id].push({
                                                        question_crosshead_index: k,
                                                        script_execute_result_message: "",
                                                        script_execute_result_score: null
                                                    })
                                                }
                                            }
                                        }

                                    } else {
                                        if (data[0].validResult) {
                                            this.validResultData[li.id] = JSON.parse(data[0].validResult)
                                        }
                                    }
                                }

                            }
                        }
                    }
                    this.getReviewResult(this.info.answerSheetId)
                    this.$forceUpdate()
                }
            })
        },
        initHistory(questionId) {
            getOperateHistory(this.info.answerSheetId,  questionId).then(res => {
                this.operateHistory[questionId] = res.data
            })
        },
        getUserId() {
            let token = Cookies.get('TipDM-Login-Token')
            let tokenValues = token.split('.')
            let payload = JSON.parse(atob(tokenValues[1].replace(/-/g, '+').replace(/_/g, '/'), "123"))['TipDM-Jwt-Payload']
            return JSON.parse(payload).userId
        },
        getReviewResult(id) {
            findResultByAnswerSheetId(id).then(res => {
                if (res.status === 200) {
                    this.answerSheetReviewResult = res.data
                    this.reviewResult = []
                    if (res.data.reviewResult != null) {
                        this.reviewResult = JSON.parse(res.data.reviewResult)
                    }
                    for (let i = 0; i < this.question.length; i++) {
                        const list = this.question[i].question_list;
                        for (let j = 0; j < list.length; j++) {
                            const li = list[j];
                            const data = this.reviewResult.filter((item) => item.questionId === li.id)
                            if (data.length) {
                                if (this.question[i].question_type == 'subjectivity') {
                                    if (data[0].scores) {
                                        li.reviewScore = data[0].scores
                                    } else {
                                        li.reviewScore = data[0].score
                                    }
                                } else {
                                    li.reviewScore = data[0].score
                                }
                                li.reviewType = data[0].type    // 错误0，正确1，部分正确2
                                li.comment = '暂无评语'
                                if (data[0].comment) {
                                    let commentArr = data[0].comment.filter(e => e !== '')
                                    if (commentArr.length > 0) {
                                        li.comment = commentArr.join("\n--------------------------------\n")
                                    }
                                }
                            }
                        }
                    }

                    this.initReviewResultTable()
                }
            })
        },
        initReviewResultTable() {
            let that = this
            this.reviewResultTable = []
            let questionTypeList = this.reviewResult.map(item => item.questionType)
            questionTypeList = [...new Set(questionTypeList)]
            questionTypeList.forEach(questionType => {
                let obj = {}
                obj.questionType = this.questionTypeDict.find(item => item.dict_value === questionType).dict_label
                // 正确
                obj.rightNum = this.reviewResult.filter(item => item.questionType === questionType && item.type === 1).length
                // 部分正确
                obj.someRightNum = this.reviewResult.filter(item => item.questionType === questionType && item.type === 2).length
                // 未答
                obj.nullNum = 0
                this.reviewResult
                    .filter(item => item.questionType === questionType)
                    .forEach(question => {
                        let already = that.examineeAnswer.find(item => item.questionId === question.questionId)
                        if (!already || already.answer.length < 1) {
                            obj.nullNum ++
                        }
                    })
                // 答错
                obj.errorNum = this.reviewResult.filter(item => item.questionType === questionType && item.type === 0).length - obj.nullNum
                obj.score = this.answerSheetReviewResult.questionTypeScoreList.find(item => item.questionType === questionType).score
                this.reviewResultTable.push(obj)
            })
        },
        reviewStatusFormatter(val) {
            let already = this.statusOptions.find(item => item.dict_value == val)
            return already ? already.dict_label : ''
        },
        goToLink(url) {
            const token = Cookies.get('TipDM-Login-Token');

            if (url.indexOf("?") != -1) {
                url = url + `&token=${token}`
            } else {
                url = url + `?token=${token}`
            }

            window.open(url, '_blank');
        },
        sumScore(score) {
            let total = 0;
            if (score != null && score.length > 0) {
                for (let i=0; i <score.length;i ++) {
                    total = total + score[i]
                }
            }
            return total;
        },
        examCountDown() {
            this.examTimer = setInterval(() => {
                let second = this.getSecondByEndTime()
                if (second <= 0) {
                    this.logout()
                }
            }, 1000);
        },
        getSecondByEndTime() {
            let nowTime = this.getNowDate().getTime()
            let endTime = new Date(this.info.examEndTime).getTime()
            return parseInt((endTime - nowTime) / 1000)
        },
        getNowDate() {
            return new Date(new Date().getTime() + this.info.timeDifference)
        },
        logout() {
            sessionStorage.clear()
            localStorage.removeItem('1+XUserIdentity')
            localStorage.removeItem('1+XPermissionsList')
            window.location.href = '/logout'
        },
        updateAnswer(questionId, subQuestionIndex, type) {
            const item = this.examineeAnswer.find(x => x.questionId === questionId);

            if (item) {
              this.answer.id = item.id;
              this.answer.content = subQuestionIndex ? item.answer[subQuestionIndex] : item.answer[0];
              this.answer.subQuestionIndex = subQuestionIndex;
              this.answer.link = item.link;
              this.answer.type = type;
              this.answer.show = true;
            } else {
              initAnswer(this.info.answerSheetId, questionId).then(()=> {
                window.location.reload()
              })
            }
        },
        updateAnswerCallback(refresh) {
            this.answer.show = false;
            if (refresh) {
                window.location.reload()
            }
        },
        updateAttachment(questionId) {
            this.answer.id = this.examineeAnswer.find(x => x.questionId === questionId).id;
            this.importDialogVisible = true;
        },
        uploadFileCallback(data) {
            this.importDialogVisible = false
            modifyAnswer({
                id: this.answer.id,
                file: data.file_path,
                fileName: data.file_name
            }).then(res => {
                if (res.status === 200) {
                    this.$message({
                        type: 'success',
                        message: '附件更新成功'
                    });
                    window.location.reload()
                }
            })
        },
    }
}
</script>
<style scoped>
    .scoreTag {
        position: absolute;
        right: 55px;
        font-size: 14px;
        margin-top: 5px;
    }
    .spaceBetween {
        display: flex;
        justify-content: space-between;
        margin-top: 14px;
    }
    .questionCon .left .box-card {
        margin-bottom: 20px;
    }
    .questionCon .right .box-card {
        height: calc(100% - 2px);
    }
    .questionCon .right .box-card >>> .el-card__body {
        height: calc(100% - 92px);
    }
    .el-descriptions >>> .el-descriptions__body {
        background: #ebeef5;
        border-radius: 4px;
        padding: 14px 20px;
    }
    .el-descriptions >>> .el-descriptions-item__label {
        margin-right: 20px;
        line-height: 28px;
        width: 70px;
        display: inline-block;
    }
    .el-descriptions >>> .el-descriptions-item__container {
        display: flex;
    }
    .el-descriptions >>> .el-descriptions-item__content {
        display: inline-block;
        width: calc(100% - 90px);
        line-height: 28px;
    }
    .answerBox {
        max-height: 200px;
        min-height: 17px;
        display: flex;
        width: calc(100% - 160px);
        overflow: auto;
        border: 1px solid #ddd;
        border-radius: 4px;
        padding: 10px;
        display: block;
    }
    .questionCon .questAnswer {
        line-height: 28px;
    }
    .questionCon .questAnswer .subjectivity {
        position: relative;
        margin-top: 4px;
    }
    .questionCon .questAnswer .subjectivity .questIndex {
        line-height: 40px;
    }

    .review-details-height {
        height: calc(100% - 10px);
    }

    .review-result-table {
        width: calc(100% - 200px);
        float: right;
    }

    .look-paper-back {
        background-color: rgb(247, 251, 255) !important;
    }
    .container {
        position: relative;
        width: auto;
        height: auto;
    }

    .edit-icon {
        position: absolute;
        right: 105px;
        bottom: 0px;
        color: #d3d3d3;
        font-size: 20px;
        cursor: pointer;
        transition: color 0.3s;
    }

    .edit-icon:hover {
        color: #0070de;
    }

</style>
<style>
.review-result-table .el-table__row .el-table__cell:nth-child(2) .cell {
    color: #67C23A !important;
}

.review-result-table .el-table__row .el-table__cell:nth-child(3) .cell {
    color: #E6A23C !important;
}

.review-result-table .el-table__row .el-table__cell:nth-child(4) .cell {
    color: #F56C6C !important;
}
.subjectivity .el-table .el-table__header th{
    background: #0b78e2;
    color: #fff;
}
</style>
